module.exports = __webpack_public_path__ + "static/media/nico-marks-min.65892a2c.jpg";